// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId, mobileView } from '../_common/api/utility';
import Button from '../_common/form/Button';
import Icon from '../_common/form/Icon';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import LocationList from '../_common/LocationList';
import { generateQR } from './WashClub';

const ColorWrap = styled.div`
    position: relative;
    overflow: hidden;
    ${({ removed }) => removed ? `
        max-height: 0;
    ` : null}
`
const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;

    padding: 0.5em 1em;
    background-color: ${({ theme, mobile }) => mobile ? theme.mobile.background : theme.body};
    border-top: 1px solid ${({ theme, mobile }) => mobile ? theme.mobile.secondary : theme.secondary};

    font-size: 0.9em;
    
    ${({ dragging }) => !dragging ? 'transition: all 0.2s;' : null}
`
const Row = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`
const Limit = styled.div`
    width: ${({ uses }) => uses ? 75 : 100}%;
`

const WalletCard = ({ ...props }) => {
    const { state: {
        // mobileView,
        isOffline
    } } = useGlobalState();

    const labeled = () => {
        if (props.isGift) return 'Gifted';
        if (props.expirationDate || props.itemType === 'DollarDiscItem' || props.itemType === 'DollarDiscTrans') return 'Claimed'
        return 'Purchased'
    }

    return (
        <ColorWrap>
            <Wrapper
                mobile={mobileView}
            >
                <Row>
                    <Col>
                        <Row>
                            <Limit uses={props.maxUses > 1}>
                                <b>· {props.name} {props.isGift ? <Icon icon='gift' /> : null}</b>
                            </Limit>
                            <b>{props.maxUses > 1 ? `Uses: ${props.useLimitCount}/${props.maxUses}` : null}</b>
                        </Row>
                        {
                            props.purchasedDate ?
                                <span>{labeled()}: {new Date(props.purchasedDate).toDateString()}</span> : null
                        } {
                            props.giftedFrom ?
                                <span>From: {props.giftedFrom}</span> : null
                        } {
                            props.giftMessage ?
                                <span>{props.giftMessage}</span> : null
                        } {
                            props.expirationDate ?
                                <span>Expiration: {(new Date(props.expirationDate).toDateString())}</span> : null
                        }
                        <LocationList itemLocations={props.locations} />
                        <Button onClick={() => generateQR(props.code, null, isOffline)} icon='QRcode'>Generate Code</Button>
                    </Col>
                </Row>
            </Wrapper>
        </ColorWrap>
    );
}

export default WalletCard;